import { render, staticRenderFns } from "./PermissionNode.vue?vue&type=template&id=0673197a&scoped=true"
import script from "./PermissionNode.vue?vue&type=script&setup=true&name=PermissionNode&lang=js"
export * from "./PermissionNode.vue?vue&type=script&setup=true&name=PermissionNode&lang=js"
import style0 from "./PermissionNode.vue?vue&type=style&index=0&id=0673197a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0673197a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0673197a')) {
      api.createRecord('0673197a', component.options)
    } else {
      api.reload('0673197a', component.options)
    }
    module.hot.accept("./PermissionNode.vue?vue&type=template&id=0673197a&scoped=true", function () {
      api.rerender('0673197a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/organization/role/permission/PermissionNode.vue"
export default component.exports